import * as types from "../constants/actionTypes";
import moment from 'moment-timezone';
import * as Tools from '../helpers/Tools';
export const videoVisitSchedulingInitialState = {

};


export default function videoVisitSchedulingReducer(state = videoVisitSchedulingInitialState, action) {
    switch (action.type) {
        case types.GET_VIDEO_VISIT_CONDITIONS_PENDING:
            return {
                ...state,
                videoVisitConditions: {
                    isWaiting: true
                }
            };
        case types.GET_VIDEO_VISIT_CONDITIONS_SUCCESS:
            return {
                ...state,
                videoVisitConditions: {
                    isWaiting: false, conditions: action.conditions, isSuccess: true, isError: null
                }
            };
        case types.GET_VIDEO_VISIT_CONDITIONS_FAILURE:
            return {
                ...state,
                videoVisitConditions: {
                    isWaiting: false, conditions: null, isSuccess: false, isError: true
                }
            };
        case types.GET_VIDEO_VISIT_TIME_SLOTS_PENDING:
            return {
                ...state,
                videoVisitTimeSlots: {
                    isWaiting: true, isSuccess: false
                }
            };
        case types.GET_VIDEO_VISIT_TIME_SLOTS_SUCCESS:
            return {
                ...state,
                videoVisitTimeSlots: {
                    isWaiting: false, timeslots: getTimeSlots(action.timeslots), isSuccess: true, isError: null
                }
            };
        case types.GET_VIDEO_VISIT_TIME_SLOTS_FAILURE:
            return {
                ...state,
                videoVisitTimeSlots: {
                    isWaiting: false, timeslots: null, isSuccess: false, isError: true
                }
            };
        case types.SCHEDULE_VIDEO_VISIT_REQUEST_PENDING:
            return {
                ...state,
                videoVisit: {
                    isWaiting: true
                }
            };
        case types.SCHEDULE_VIDEO_VISIT_REQUEST_SUCCESS:
            return {
                ...state,
                videoVisit: {
                    isWaiting: false,
                    isSuccess: true,
                    isError: null,
                    response: action.response
                }
            };
        case types.SCHEDULE_VIDEO_VISIT_REQUEST_FAILURE:
            return {
                ...state,
                videoVisit: {
                    isWaiting: false,
                    isSuccess: false,
                    isError: true,
                    response: null
                }
            };
        case types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_PENDING:
            return {
                ...state,
                videoSurvey: { isWaiting: true, isSuccess: false, isFailure: false }
            };
        case types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_SUCCESS:
            return {
                ...state,
                videoSurvey: { isWaiting: false, isSuccess: true, isFailure: false }
            };
        case types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_FAILURE:
            return {
                ...state,
                videoSurvey: { isWaiting: false, isSuccess: false, isFailure: true }
            };
        case types.GET_VIDEO_VISIT_TERMS_PENDING:
            return {
                ...state,
                videoVisitTerms: {
                    isWaiting: true
                }
            };
        case types.GET_VIDEO_VISIT_TERMS_SUCCESS:
            return {
                ...state,
                videoVisitTerms: {
                    isWaiting: false, terms: action.terms, isSuccess: true, isError: null
                }
            }
        case types.GET_VIDEO_VISIT_TERMS_FAILURE:
            return {
                ...state,
                videoVisitTerms: {
                    isWaiting: false, terms: null, isSuccess: false, isError: action.error
                }
            };
        case types.ACCEPT_VIDEO_VISIT_CONDITIONS_PENDING:
            return {
                ...state,
                acceptVideoVisitTerms: {
                    isWaiting: true
                }
            }
        case types.ACCEPT_VIDEO_VISIT_CONDITIONS_SUCCESS:
            return {
                ...state,
                acceptVideoVisitTerms: {
                    isWaiting: false, isSuccess: true, isError: null
                }
            }
        case types.ACCEPT_VIDEO_VISIT_CONDITIONS_FAILURE:
            return {
                ...state,
                acceptVideoVisitTerms: {
                    isWaiting: false, isSuccess: false, isError: action.error
                }
            }

        default:
            return { ...state };

    }
}

function getTimeSlots(timeslots)  {
    let timeChunks = [];
    const today = Tools.getCurDateInCentralTz(); //moment().startOf('date').tz('America/Chicago');
    const todayDate = today.format('YYYY-MM-DDT00:00:00');
    const tomorrowDate = today.add(1, 'days').format('YYYY-MM-DDT00:00:00');
    const availableTimes = [
        {
            dateInUtc: `${todayDate}Z`,
            dateInDallas: `${todayDate}`,
            dateLabel: "TODAY",
            morning: [],
            afternoon: [],
            evening: []
        },
        {
            dateInUtc: `${tomorrowDate}Z`,
            dateInDallas: `${tomorrowDate}`,
            dateLabel: "TOMORROW",
            morning: [],
            afternoon: [],
            evening: []
        }
    ];
    //// Get all available timechunks
    timeslots && timeslots.availableTimes && timeslots.availableTimes.length > 0
        && timeslots.availableTimes.forEach(item => {
            timeChunks = timeChunks.concat(item.timeChunks);
        });
    // Sort all timechunks according to dateTimeInDallas
    timeChunks = timeChunks.sort((initialChunk, currChunk) => {
        const aTime = moment(initialChunk.dateTimeInDallas);
        if (aTime.isBefore(currChunk.dateTimeInDallas)) {
            return -1;
        } else {
            return aTime.isAfter(currChunk.dateTimeInDallas) ? 1 : 0;
        }
    });
    timeChunks.forEach(timeChunk => {
        const timeDate = moment(timeChunk.dateTimeInDallas);
        const dayIndex = timeDate.isSame(todayDate, 'day') ? 0 : timeDate.isSame(tomorrowDate, 'day') ? 1 : null;
        if (dayIndex !== null) {
            switch (timeChunk.timeChunkLabel) {
                case "Morning":
                    availableTimes[dayIndex].morning.push(timeChunk);
                    break;
                case "Afternoon":
                    availableTimes[dayIndex].afternoon.push(timeChunk);
                    break;
                case "Evening":
                    availableTimes[dayIndex].evening.push(timeChunk);
                    break;
                default:
                    break;
            }
        }
    });
    return availableTimes;
}